import { createAction } from 'typesafe-actions';
import { IPublicRestaurant, IRestaurantAvailableTimes, IRestaurantAvailableTimesRequest } from '@localina/core';
import { IRestaurantPublicMenu, IShiftOverview } from '../../interfaces';

const RESTAURANT_CONFIGURATION_REQUESTED = 'RESTAURANT CONFIGURATION REQUESTED';
export const restaurantConfigurationRequested = createAction(
    RESTAURANT_CONFIGURATION_REQUESTED,
    (restaurantId: string) => ({
        restaurantId,
    }),
)();

const RESTAURANT_CONFIGURATION_RECEIVED = 'RESTAURANT CONFIGURATION RECEIVED';
export const restaurantConfigurationReceived = createAction(
    RESTAURANT_CONFIGURATION_RECEIVED,
    (configuration: IPublicRestaurant) => ({ configuration }),
)();

const RESTAURANT_CONFIGURATION_FAILED = 'RESTAURANT CONFIGURATION FAILED';
export const restaurantConfigurationFailed = createAction(RESTAURANT_CONFIGURATION_FAILED, (err: any) => err)();

const RESTAURANT_AVAILABLE_TIMES_REQUESTED = 'RESTAURANT AVAILABLE TIMES REQUESTED';
export const restaurantAvailableTimesRequested = createAction(
    RESTAURANT_AVAILABLE_TIMES_REQUESTED,
    (restaurantId: string, data: IRestaurantAvailableTimesRequest) => ({
        restaurantId,
        data,
    }),
)();

const RESTAURANT_AVAILABLE_TIMES_RECEIVED = 'RESTAURANT AVAILABLE TIMES RECEIVED';
export const restaurantAvailableTimesReceived = createAction(
    RESTAURANT_AVAILABLE_TIMES_RECEIVED,
    (availableTimes: IRestaurantAvailableTimes) => ({ availableTimes }),
)();

const RESTAURANT_AVAILABLE_TIMES_FAILED = 'RESTAURANT AVAILABLE TIMES FAILED';
export const restaurantAvailableTimesFailed = createAction(RESTAURANT_AVAILABLE_TIMES_FAILED, (err: any) => err)();

const RESTAURANT_MENU_REQUESTED = 'RESTAURANT MENU REQUESTED';
export const restaurantMenuRequested = createAction(RESTAURANT_MENU_REQUESTED, (restaurantId: string) => ({
    restaurantId,
}))();
const RESTAURANT_MENU_RECEIVED = 'RESTAURANT MENU RECEIVED';
export const restaurantMenuReceived = createAction(
    RESTAURANT_MENU_RECEIVED,
    (response: IRestaurantPublicMenu) => response,
)();

const RESTAURANT_MENU_FAILED = 'RESTAURANT MENU FAILED';
export const restaurantMenuFailed = createAction(RESTAURANT_MENU_FAILED, (err: any) => err)();

const SHIFTS_REQUESTED = 'SHIFTS REQUESTED';
export const shiftsRequested = createAction(SHIFTS_REQUESTED, (date: string, participants: number) => ({
    date,
    participants,
}))();
const SHIFTS_RECEIVED = 'SHIFTS RECEIVED';
export const shiftsReceived = createAction(SHIFTS_RECEIVED, (shifts: IShiftOverview[]) => ({
    shifts,
}))();

const SHIFTS_ERROR = 'SHIFTS ERROR';
export const shiftsError = createAction(SHIFTS_ERROR, (err: any) => err)();
